var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-summary',{attrs:{"cells":_vm.summary}}),_c('report-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"initialSortedColumns":['floor']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }